



















import { Component, Prop, Vue } from 'vue-property-decorator';

interface LocaleOption {
    locale: string;
    title: string;
}

@Component({})
export default class LocalesPicker extends Vue {
    @Prop() private availableLocales!: string[];
    @Prop() private locale!: string;

    get availableLocalesOptions(): LocaleOption[] {
        return this.availableLocales.map((locale) => {
            return {
                locale,
                title: this.$parent.$t(`locales.${locale}`) as string
            };
        });
    }
}
